import {useRouter} from 'next/router';
import {prefix, validateParams} from '../../services/plp-url-params';

const useUrl = (basePath = '') => {
  const router = useRouter();

  /**           GLOBAL FUNCTIONS           **/

  const write = (paramsObject) => {
    const params = prefix(paramsObject);
    const pathName = basePath + params.join('/');
    router.push({pathname: pathName}, undefined, {shallow: true});
    return params;
  };

  const read = () => {
    const rawParams = router.query.param ? [...router.query.param] : [];
    const params = validateParams(rawParams);
    return params;
  };

  return {write, read};
};

export default useUrl;
